import Link from 'next/link'
import { Button, Row } from 'antd'
import React, { useState } from 'react'
import { Project } from 'src/core/models'
import { CustomCol } from 'src/components'
import { useTranslation } from 'next-i18next'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import { userAuthenticatedState } from 'src/features'
import { EditOutlined, ShareAltOutlined } from '@ant-design/icons'
import styles from './ProjectPriceDetailButtonsContent.module.scss'
import ProjectTransferModal from '../ProjectTransferModal/ProjectTransferModal'

const ProjectPriceDetailButtonsContent: React.FC<{ project: Project }> = ({ project }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const user = useAppSelector(userAuthenticatedState)
  const { width } = useWindowSize()

  const isShareButtonVisible = !project.is_active && user.is_superuser

  return (
    <>
      <Row className={width > 800 ? 'mt-5' : ''}>
        <CustomCol className='centered-div' lg={isShareButtonVisible ? 12 : 24}>
          {/* Edit Button */}
          <Link href={`/my-projects/edit?id=${project.id}`} legacyBehavior>
            <a>
              <Button
                type='primary'
                htmlType='button'
                size='large'
                icon={<EditOutlined />}
                className={width > 800 ? 'ml-5 radius-100' : 'radius-100'}
              >
                {t('Edit Project')}
              </Button>
            </a>
          </Link>
        </CustomCol>
        <CustomCol className='centered-div'>
          {/* Share Project Button */}
          {isShareButtonVisible && (
            <Button
              htmlType='button'
              size='large'
              icon={<ShareAltOutlined />}
              className={width > 800 ? styles.shareButton : 'radius-100'}
              onClick={() => setIsModalVisible(true)}
            >
              {t('Transfer Ownership')}
            </Button>
          )}
        </CustomCol>
      </Row>

      <ProjectTransferModal
        project={project}
        isModalVisible={isModalVisible}
        handleCancel={() => setIsModalVisible(false)}
      />
    </>
  )
}

export default ProjectPriceDetailButtonsContent
